import { SearchOutlined } from '@ant-design/icons';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { HeaderTitle, SearchMachine, Pagination } from 'components';
import { MachineRequestState } from 'types';
import { RootState } from '../../types/store';
import TableMachine from './TableMachine';
import { resetSearchValue, setCurrentPage, setSearchValue } from './slices';
import Wrap from './styles';
import { getListMachine } from './thunk';

const ListMachine: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { totalItems, items, currentPage, searchValue } = useSelector((state: RootState) => state.machine);

  useEffect(() => {
    const search = searchValue
      ? {
          lease_start_date: searchValue?.lease_start_date,
          lease_end_date: searchValue?.lease_end_date,
          lease_contract_date: searchValue?.lease_contract_date,
          lease_company: searchValue?.lease_company,
          lease_contract_id: searchValue?.lease_contract_id,
          machine_quantity: searchValue?.machine_quantity,
        }
      : undefined;
    dispatch(
      getListMachine({
        pageNumber: currentPage,
        searchValue: search,
      }),
    );
  }, [dispatch, currentPage, searchValue]);

  useEffect(() => {
    return () => {
      if (history.location.pathname !== '/machine/detail') {
        dispatch(resetSearchValue());
      }
    };
  }, [dispatch, history.location.pathname]);

  const onChangeValueSearch = (values: MachineRequestState) => {
    dispatch(setSearchValue(values));
    dispatch(setCurrentPage(1));
  };
  const onChangePage = (page: number) => {
    dispatch(setCurrentPage(page));
  };

  return (
    <Wrap>
      <HeaderTitle title="機器管理・リース契約一覧" icon={SearchOutlined} />
      <SearchMachine onSearch={onChangeValueSearch} />
      <div className="section">
        <Pagination totalItems={totalItems} page={currentPage} onChangePage={onChangePage} />
        <div className="table">
          <TableMachine data={items} />
        </div>
      </div>
    </Wrap>
  );
};
export default ListMachine;
